import { CSSProperties, Fragment } from 'react';

// A localized sentence with a phone number inside it, isolated for bidi.
//
// Without `<bdi>` the leading `+` is bidi-neutral, so in an RTL sentence it
// resolves to the paragraph direction and renders on the WRONG side of the digits
// ("972544561106+"). Both onboarding code screens show the number they texted, so
// the isolation lives here rather than being re-derived per brand.
//
// The number is located by splitting the translated line on its own value, so word
// order comes from the translation instead of being hard-coded around the markup.
// If the value isn't present verbatim — e.g. a translator renamed the {phone}
// placeholder, so ICU returned the raw template — the line renders as-is rather
// than gaining a duplicate.
export function SentenceWithPhone({
  line,
  phone,
  phoneStyle,
}: {
  line: string;
  phone: string;
  phoneStyle?: CSSProperties;
}) {
  if (!phone || !line.includes(phone)) return <>{line}</>;
  const parts = line.split(phone);
  return (
    <>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 && <bdi style={phoneStyle}>{phone}</bdi>}
          {part}
        </Fragment>
      ))}
    </>
  );
}
